import React, { useState } from "react";
import {
  Navbar,
  Nav,
  Offcanvas,
  Button,
  Container,
  NavDropdown,
} from "react-bootstrap";
import { List } from "lucide-react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthService } from "../services/AuthService";

const AppNav = () => {
  const navigate = useNavigate();
  const logout = () => {
    AuthService.logout();
    navigate("/login");
  };

  const [show, setShow] = useState(false);
  const location = useLocation();
  const roleDetails = AuthService.getUserRole();
  const roleName = roleDetails?.role;

  const handleClose = () => setShow(false);

  const menus = {
    superAdmin: [
      { to: "/secondary-screening-members", label: "Secondary Screening Members" },
      { to: "/secondary-screening-camp", label: "Secondary Screening Camps" },
      { to: "/hospitals", label: "Hospitals" },
      { to: "/users", label: "Users" },
      { to: "/asha", label: "Ashas" },
      { to: "/patients-history", label: "Patients" },
    ],
    adminLimited: [
      { to: "/secondary-screening-camp", label: "Secondary Screening Camps" },
      { to: "/asha", label: "Ashas" },
      { to: "/patients-history", label: "Patients" },
    ],
    phc: [
      { to: "/secondary-screening-camp", label: "Secondary Screening Camps" },
      { to: "/asha", label: "Ashas" },
      { to: "/asha-abstract-report", label: "Asha Abstract Report" },
      { to: "/patients-history", label: "Patients" },
    ],
    hospital: [
      { to: "/secondary-screening-camp", label: "Secondary Screening Camps" },
      { to: "/secondary-screening-members", label: "Secondary Screening Members" },
      { to: "/patients-history", label: "Patients" },
    ],
  };

  let currentMenu = [];
  if (roleName === "Super Admins") {
    currentMenu = menus.superAdmin;
  } else if (roleName === "PHC") {
    currentMenu = menus.phc;
  } else if (["Taluk", "Asha Block"].includes(roleName)) {
    currentMenu = menus.adminLimited;
  } else if (roleName === "Hospital") {
    currentMenu = menus.hospital;
  }

  return (
    <>
      <Navbar bg="dark" variant="dark" expand="lg" className="p-3">
        <Container>
          <Button variant="dark" onClick={() => setShow(true)}>
            <List size={24} />
          </Button>
          <Navbar.Brand as={Link} to="/dashboard" className="mx-auto">
            BLINDNESS FREE SHIMOGA
          </Navbar.Brand>
          <Navbar.Brand className="ms-3">
            <Button variant="light" onClick={logout}>
              Log Out
            </Button>
          </Navbar.Brand>
        </Container>
      </Navbar>

      <Offcanvas show={show} onHide={handleClose} placement="start">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column">

          {roleName !== "Hospital" && (
              <>
            <Nav.Link
              as={Link}
              to="/dashboard"
              onClick={handleClose}
              className={
                location.pathname === "/dashboard"
                  ? "bg-primary text-white"
                  : "text-black"
              }
            >
              Dashboard
            </Nav.Link>
            </>
          )}

            {/* Master Data only for Super Admin */}
            {roleName === "Super Admins" && (
              <>
                <NavDropdown title="Master Data" id="master-data-dropdown">
                  <NavDropdown.Item
                    as={Link}
                    to="/taluk"
                    onClick={handleClose}
                    className={
                      location.pathname === "/taluk"
                        ? "bg-primary text-white"
                        : "text-black"
                    }
                  >
                    Taluks
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="/phc"
                    onClick={handleClose}
                    className={
                      location.pathname === "/phc"
                        ? "bg-primary text-white"
                        : "text-black"
                    }
                  >
                    PHCs
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="/asha-block"
                    onClick={handleClose}
                    className={
                      location.pathname === "/asha-block"
                        ? "bg-primary text-white"
                        : "text-black"
                    }
                  >
                    ASHA Blocks
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="/followup-place"
                    onClick={handleClose}
                    className={
                      location.pathname === "/followup-place"
                        ? "bg-primary text-white"
                        : "text-black"
                    }
                  >
                    Follow Up Places
                  </NavDropdown.Item>
                </NavDropdown>

                {/* Reports Menu */}
                <Nav.Link
                  as={Link}
                  to="/reports"
                  onClick={handleClose}
                  className={
                    location.pathname === "/reports"
                      ? "bg-primary text-white"
                      : "text-black"
                  }
                >
                  Reports
                </Nav.Link>
              </>
            )}

            {/* Other Menus */}
            {currentMenu.map((item) => (
              <Nav.Link
                key={item.to}
                as={Link}
                to={item.to}
                onClick={handleClose}
                className={
                  location.pathname === item.to
                    ? "bg-primary text-white"
                    : "text-black"
                }
              >
                {item.label}
              </Nav.Link>
            ))}
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default AppNav;
